import { moduleFactory } from "@/factories/module";
import { createCheckoutSessionAndNavigate } from "./checkout";
import { getBillingPortalAndNavigate } from "./billing-portal";
import {
  parseUpgradePlanQueryParams,
  parseStripeQueryParams,
  buildStripeReturnUrl,
  buildStripeSuccessUrl,
  buildStripeCancelUrl,
  buildStripeBillingReturnUrl,
} from "./query-params";
import { isAppleProvider } from "./provider";

export const subscriptionModule = moduleFactory.create({
  createCheckoutSessionAndNavigate,
  getBillingPortalAndNavigate,
  parseUpgradePlanQueryParams,
  parseStripeQueryParams,
  buildStripeReturnUrl,
  buildStripeSuccessUrl,
  buildStripeCancelUrl,
  buildStripeBillingReturnUrl,
  isAppleProvider,
});
